<dx-text-box
  class="flex-grow-1 np-highlight"
  style="width: 450px;"
  label="{{ 'Feld' | translate }}"
  placeholder="{{ 'Feld auswählen' | translate }}"
  [(value)]="templateItem.defaultValue"
  (onValueChanged)="onUpdate.emit()"
></dx-text-box>
